import {ArticleDateTime} from '@shared/Articles/ArticleSlug/ArticleDateTime/ArticleDateTime';
import classNames from '@sindresorhus/class-names';
import Link from 'next/link';
import {Fragment} from 'react';

import {ArticleType} from '@strapi/types';

import styles from './ArticleHead.module.scss';

const MAX_CATEGORY_ITEMS_IN_ROW = 5;

export const ArticleHead = ({
  article,
  enableCategoriesPages,
  placement,
  menuItemClickAnalytics,
}: {
  article: ArticleType;
  enableCategoriesPages: boolean;
  placement: 'prostore' | 'blog';
  menuItemClickAnalytics?: (category: string) => void;
}) => {
  const handleMenuItemClick = (category: string) => {
    if (menuItemClickAnalytics) {
      return menuItemClickAnalytics(category);
    }
  };
  return (
    <div
      className={classNames(styles.infoBlock, {
        [styles.infoBlock_column]:
          article?.categories?.length > MAX_CATEGORY_ITEMS_IN_ROW,
      })}
    >
      {!!article.categories?.length && (
        <div className={styles.categories} key={article.id}>
          {article.categories.map((elem) => (
            <Fragment key={elem.categoryName}>
              {enableCategoriesPages ? (
                <Link
                  key={elem.categoryName}
                  className={styles.category}
                  href={`/${placement}/categories/${elem.categoryUrl}`}
                  onClick={() => handleMenuItemClick(elem.categoryName)}
                >
                  {elem.categoryName}
                </Link>
              ) : (
                <div key={elem.categoryName} className={styles.category}>
                  {elem.categoryName}
                </div>
              )}
            </Fragment>
          ))}
        </div>
      )}
      <ArticleDateTime
        updatedAt={article.updatedAt}
        createdAt={article.publishedAt}
        timeToRead={article.timeToRead}
        isArticlePage={true}
        className={styles.timeInfo}
        isColumnView={
          article?.categories?.length > MAX_CATEGORY_ITEMS_IN_ROW ||
          !article.categories?.length
        }
      />
    </div>
  );
};
